import { useQuery } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import type { GetVacancyRequest, Vacancy } from '@entities/vacancy';
import { QueryKey } from '@shared/config';

export const useGetVacancy = ({ id }: GetVacancyRequest) => {
  return useQuery<Vacancy>({
    queryKey: [QueryKey.GET_VACANCY, id],
    queryFn: () => vacancyApi.getVacancy({ id }),
    enabled: Boolean(id),
    retry: false,
  });
};
